import React from 'react';

import E9ToolBarMore from '../ecology9/E9ToolBarMore';

class E8ToolBarMore extends React.Component {
  render() {
    return (
      <div className="e8header-toolbar-more">
        <E9ToolBarMore ecId={`${(this && this.props && this.props.ecId) || ''}_E9ToolBarMore@sz8w69`} />
      </div>
    );
  }
}

export default E8ToolBarMore;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8ToolBarMore.js